import React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { getCurrentYear } from "../../shared/shared";
import {ROTH_DESTINATION_ROTH_IRA, ROTH_DESTINATION_RILA, ROTH_DESTINATION_LEVEL_INCOME_FIA, ROTH_DESTINATION_INCREASING_PAYOUT_FIA, ROTH_DESTINATION_VOLATILITY_BUFFER_FIA} from "../../shared/constants";

const YearCell = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value
      });
    }
  };

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];

  if (field === 'transferEndYear' && (dataItem.isAccountRothConversionIntoFIA || dataItem.insuranceType === "GUARANTEED_INCOME")) return <td></td>

  if (!dataItem.inEdit) {
    return <td>
      {dataValue}
    </td>
  }

  if (props.dataItem.annuityType === "GUARANTEED_INCOME" && field === "transferEndYear") {
    return <td >
      <NumericTextBox
        label={" "}
        value={props.dataItem.transferStartYear} //value setin getPayloadFuturePlan()
        disabled={true}
        format={"'#'"}
        valid={true}
      />
    </td>
  }



  return (
    <td >
      <NumericTextBox
        label={" "}
        autoFocus="autoFocus"
        value={dataValue}
        onChange={handleChange}
        format={"'#'"}
        min={getCurrentYear()}
        max={getCurrentYear() + 100}
        valid={(dataValue >= getCurrentYear() && dataValue <= (getCurrentYear() + 100))}
      />
    </td>
  );
};

export const RothConversionTransferEndYearCell = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value
      });
    }
  };

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];

  switch(dataItem.destination) {
    case ROTH_DESTINATION_ROTH_IRA: return <td></td>;
    case ROTH_DESTINATION_VOLATILITY_BUFFER_FIA:
    case ROTH_DESTINATION_LEVEL_INCOME_FIA:
    case ROTH_DESTINATION_INCREASING_PAYOUT_FIA:
      return <td>{dataItem[props.field]}</td>
    case ROTH_DESTINATION_RILA:
      return <td>
        <NumericTextBox
            label={" "}
            autoFocus="autoFocus"
            value={dataValue}
            onChange={handleChange}
            format={"'#'"}
            min={getCurrentYear()}
            max={getCurrentYear() + 100}
            valid={(dataValue >= getCurrentYear() && dataValue <= (getCurrentYear() + 100))}
        />
      </td>
    default:
      return <td></td>
  };
};

export default YearCell;
